window.GTMEventTracking = (function() {
  window.dataLayer = window.dataLayer || [];

  return {
    contactUsLinkClick(contactType) {
      window.dataLayer.push({event: 'contact_us', contact_type: contactType});
    },
    socialMediaLinkClick(href) {
      window.dataLayer.push({event: 'social_profile_click', click_destination: href});
    },
  };
})();
